import dayjs from "dayjs"

export const sameDate = (value1: string, value2: string) => {
  const date1 = dayjs(value1)
  const date2 = dayjs(value2)
  return date1.isSame(date2, "day")
}
